<div id="flowspace">
    <app-sidebar [service]="messageService"></app-sidebar>
    <div id="content_pane" *ngIf="wallpaper_set==null" [style.background]="'url(../../../assets/' + wallpaper + '.jpg)'"[style.backgroundSize]="'cover'" [style.backgroundRepeat]="'no-repeat'">
        <router-outlet></router-outlet>
    </div>
    <div id="content_pane" *ngIf="wallpaper_set!=null" [style.background]="'url(../../../assets/' + wallpaper_set + '.jpg)'" [style.backgroundSize]="'cover'" [style.backgroundRepeat]="'no-repeat'">
        <router-outlet></router-outlet>
    </div>
</div>
